import {
  FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  WebWidth,
  WebLeft,
  CSP,
} from "../../config/config";
import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_MASTERCATEGORY,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  set_dto_selected_final_merchant_or_product,
  set_dto_selected_merchant_or_product,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import {
  STORE_FAVOURITE_MERCHANT_LIST,
  STORE_PRODUCT_LIST,
  STORE_DineType,
} from "../../database/store-names";
import {
  GET_CART_SELECT_MERCHATS_ZONE,
  GET_SET_STORED_DATA,
  GET_CART,
} from "../../database/get-stored-data";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_LoadProductListToMobileAppForAnMID } from "../../connection/api/api-product-list";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { api_UpdateIsFavouriteForMerchant } from "../../connection/api/api-home";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { SET_STORE_DINE_TYPE } from "../../database/store-data";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_Merchant } from "../../classes/dto-merchant";
import { dto_common } from "../../classes/dto-common";
import { F_Fammily } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import QuickCartButton from "./components/quick-cart-button/quick-cart-button";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import PlaceHolder from "./components/product-list-place-holder/product-list-place-holder";
import Category from "./components/product-lisit-category/product_list_category";
import ItemView from "./components/product-list-item/product-list-item";
import React from "react";
import "../../styles/css/pg-product-list.css";
import "../../styles/css/fixedbutton.css";
import "../../styles/css/animate.css";
var $ = require("jquery");
const cloneDeep = require("lodash.clonedeep");

export default class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CateList: [],
      PrdList: [],
      inMemoryProducts: [],
      isLoading: true,
      displayMessage: false,
      desc: "",
      DrawerIsOpen: false,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: 0,
      LocalCart: [],
      IsSummaryCart: false,
      ActiveIndex: 0,
      PaddingLeft: "14%",
      DelPaddingLeft: "17%",
      MainTopMargin: "0px",
      iconDisplay: "block",
      deliveryDisabled: false,
      takeawayDisabled: false,
      MerchantData: [],
      filterText: "",
      IsFavourite: false,
      SwitchCategory: false,
      CategoryList: [],
      showDropdown: false,
      showSortDropDown: false,
      activeCategoryId: null,
      selectedCategoryLabel: "Category",
    };
    this.safariTouchFixTimer = null;
    this.keepCheckInterval = null;
    this.lastCartSignature = "";
  }

  getCartSignature = (cart = []) =>
    cart
      .map(
        (item) =>
          `${item.PID}:${item.LineID}:${item.ADDONLINEID}:${item.Qty}:${item.UP}`,
      )
      .join("|");

  refreshLocalCart = async () => {
    let cart = await GET_CART();
    if (cart === undefined) {
      cart = [];
    }

    const nextSignature = this.getCartSignature(cart);
    if (nextSignature !== this.lastCartSignature) {
      this.lastCartSignature = nextSignature;
      this.setState({ LocalCart: cart });
    }
  };

  async componentDidMount() {
    document
      .querySelectorAll(".shadow-overlay")
      .forEach((node) => node.remove());
    let HeaderCommonId = document.getElementById("DivHeaderHome");
    if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
      HeaderCommonId.style.display = "none";
    }
    if (CSP === "MK") {
      this.setState({ SwitchCategory: false });
      localStorage.setItem("isAllCat", false);
    }
    if (CSP === "DT") {
      if (dto_selected_merchant_or_product.Merchant === "MKB Supermarket") {
        localStorage.setItem("isAllCat", false);
        ENCRYPT_STORAGE.removeItem(STORE_PRODUCT_LIST);
      } else {
        dto_selected_merchant_or_product.CATID = 0;
      }
    }

    await GET_SET_STORED_DATA();
    if (this.props.params.navPage === "cart") {
      const cartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
      if (cartMerchant) {
        await set_dto_Merchant(cartMerchant);
        await set_dto_selected_final_merchant_or_product(cartMerchant);
        await set_dto_selected_merchant_or_product(cartMerchant);
      }
    }
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: dto_selected_merchant_or_product.Merchant,
      }),
      FnGoBackScreen: () => {
        if (
          dto_selected_merchant_or_product.MT === "RS" &&
          dto_selected_final_merchant_or_product.CSP !== "MK"
        ) {
          if (this.props.params.navPage === "home-filter") {
            this.props.navigate(
              PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "home"),
            );
          } else if (this.props.params.navPage === "home") {
            this.props.navigate(PT_HOME);
          } else {
            if (CSP === "MK") {
              this.props.navigate(PT_MASTERCATEGORY);
            } else {
              this.props.navigate(PT_HOME);
            }
          }
        } else {
          if (this.props.params.navPage === "shome") {
            this.props.navigate(PT_HOME);
          } else {
            this.props.navigate(PT_MASTERCATEGORY);
          }
        }
      },
      HeaderNavigatorMenuDisplay: true,
      FnHeaderNavigatorMenu: () => {
        this.TransformationFillterTextBox();
      },
    });
    await this.LoadMasterCategory();
    await this.LoadProduct();

    await api_DaitonnAnalytical();

    await this.Setdinetype();
    this.keepCheckInterval = setInterval(() => {
      this.refreshLocalCart();
    }, 750);
    if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
      this.checkIsFavourite();
    }
  }

  componentWillUnmount() {
    const element = this.handleScroll
      ? isMobile
        ? document.querySelector(".body-container")
        : document.querySelector(".WindowDevice")
      : null;
    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
      this.safariTouchFixTimer = null;
    }
    clearInterval(this.keepCheckInterval);
  }

  safariTouchFix = () => {
    const body = document.body;
    if (!body) {
      return;
    }
    body.style.pointerEvents = "auto";
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
    }
    requestAnimationFrame(() => {
      body.style.pointerEvents = "auto";
    });
    this.safariTouchFixTimer = setTimeout(() => {
      body.style.pointerEvents = "auto";
      this.safariTouchFixTimer = null;
    }, 400);
  };

  getScrollContainer = () => {
    if (isMobile) {
      return (
        document.querySelector(".body-container") ||
        document.scrollingElement ||
        document.documentElement ||
        document.body
      );
    }

    return (
      document.querySelector(".WindowDevice") ||
      document.scrollingElement ||
      document.documentElement ||
      document.body
    );
  };

  focusSearchInput = () => {
    setTimeout(() => {
      const input = document.getElementById("InputproductlistFilterTextBox");
      if (input) {
        input.focus();
      }
    }, 50);
  };

  setSelectedCategoryLabel = (categoryName = "") => {
    const nextLabel =
      categoryName.length > 25
        ? categoryName.slice(0, 25) + "..."
        : categoryName;
    this.setState({
      selectedCategoryLabel: nextLabel || "Category",
    });
    const selectedCat = document.getElementById("SelectedCat");
    if (!selectedCat) {
      return;
    }
    selectedCat.innerText = nextLabel;
  };

  syncHorizontalCategory = (categoryId) => {
    const hContainer = document.getElementById("horizontalCateSection");
    if (!hContainer || categoryId === undefined || categoryId === null) {
      return;
    }

    const activeBtn = hContainer.querySelector(
      `[data-catid="${String(categoryId)}"]`,
    );

    if (!activeBtn) {
      return;
    }

    const left =
      activeBtn.offsetLeft -
      hContainer.clientWidth / 2 +
      activeBtn.clientWidth / 2;

    hContainer.scrollTo({
      left: Math.max(0, left),
      behavior: "smooth",
    });
  };

  syncActiveCategory = (categoryId, categoryName = "") => {
    if (categoryName) {
      this.setSelectedCategoryLabel(categoryName);
    }

    const nextCategoryId = String(categoryId);
    if (this.state.activeCategoryId !== nextCategoryId) {
      this.setState({ activeCategoryId: nextCategoryId }, () => {
        this.syncHorizontalCategory(nextCategoryId);
      });
      return;
    }

    this.syncHorizontalCategory(nextCategoryId);
  };

  scrollToTarget = (targetId, offset = 105) => {
    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    const container = this.getScrollContainer();
    if (!container) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const isDocumentContainer =
      container === document.body ||
      container === document.documentElement ||
      container === document.scrollingElement;

    if (isDocumentContainer) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const nextTop =
      container.scrollTop + (targetRect.top - containerRect.top) - offset;

    container.scrollTo({
      top: Math.max(0, nextTop),
      behavior: "smooth",
    });
  };

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0,
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  render() {
    return (
      <div
        id="OnScrollProdcutList"
        style={{
          marginBottom: 55,
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
          marginTop:
            CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
              ? "44px"
              : this.state.MainTopMargin,
        }}
      >
        <div
          id="NewFilterationTextBox"
          className="fadeInBottom cssanimation"
          style={{
            display: "none",
            position: "absolute",
            paddingTop: "5px",
            top: 0,
            height: 50,
            width: "100%",
            zIndex: 1800,
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* textbox */}
            <input
              className="productlistFilterTextBox"
              type="text"
              style={{
                width: "90%",
                height: 50,
                border: "none",
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                paddingLeft: "8px",
              }}
              value={this.state.filterText}
              placeholder="Fillter Items"
              id="InputproductlistFilterTextBox"
              onChange={this.handleFilterChange}
            />

            {/* circle close */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderRight: "1px solid gray",
                color: "#a1a1a1",
                backgroundColor: "#fff",
                padding: "7px",
              }}
              id="btnproductlistFilterTextBoxclear"
              onClick={this.resetFilter}
            >
              <i className="bi bi-x-circle-fill" />
            </button>

            {/* cancel */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                backgroundColor: "white",
                fontFamily: F_Fammily.Medium,
                fontWeight: "600",
              }}
              id="btnproductlistFilterTextBoxClsoe"
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>

        {this.state.isLoading ? (
          <PlaceHolder />
        ) : (
          <>
            <div
              style={{
                display:
                  CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                    ? "none"
                    : "block",
              }}
            >
              {/* Parent div with relative positioning */}
              <div style={{ position: "relative" }}>
                <img
                  src={this.state.MerchantData.IL}
                  style={{ width: "100%", height: 180, objectFit: "cover" }}
                  alt={this.state.MerchantData.IL}
                />

                {/* Back Icon */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "5px",
                    fontSize: 24,
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  onClick={() => {
                    if (dto_selected_merchant_or_product.MT === "RS") {
                      if (this.props.params.navPage === "home-filter") {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "home",
                          ),
                        );
                      } else {
                        this.props.navigate(PT_HOME);
                      }
                    } else {
                      this.props.navigate(PT_MASTERCATEGORY);
                    }
                  }}
                >
                  <i className="bi bi-arrow-left" />
                </div>

                {/* Search Icon */}
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    top: "10px",
                    right: "5px",
                    fontSize: 24,
                    color: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  id="HeaderNavigatorBoostrapIcon"
                  onClick={() => {
                    const el = document.getElementById("NewFilterationTextBox");
                    if (el) {
                      el.classList.add("active");
                      $("#NewFilterationTextBox").fadeIn(500);
                      this.focusSearchInput();
                    }
                  }}
                >
                  <i className="bi bi-search" />
                </div>

                {/* Is Favourite */}
                {dto_Customer.CSID !== 0 && CSP === "AV" ? (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "5px",
                      width: "fit-content",
                      backgroundColor: this.state.IsFavourite
                        ? "rgba(255, 255, 255, 0.25)"
                        : null,
                      color: this.state.IsFavourite ? "red" : "lightgrey",
                      padding: "6px",
                      borderRadius: "5px",
                    }}
                  >
                    <i
                      className="bi bi-heart-fill"
                      onClick={(event) => this.handleHeartClick(event)}
                    />
                  </div>
                ) : null}
              </div>

              {/* Merchant Info Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 5px",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    display: CSP === "DT" || CSP === "MK" ? "none" : "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-shop" style={{ paddingRight: "8px" }} />
                  {this.state.MerchantData.Merchant}
                </div>

                <div
                  style={{
                    display: this.state.MerchantData.AR > 0 ? "flex" : "none",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-hand-thumbs-up-fill" />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {" "}
                    {this.state.MerchantData.AR}%
                  </span>
                </div>

                <div
                  style={{
                    display: "none",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      marginLeft: "5px",
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    {this.state.MerchantData.MS}
                  </span>
                </div>
              </div>

              <div
                className="commonnWrap"
                style={{
                  marginLeft: CSP !== "AV" ? "11%" : "",
                  display:
                    CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                      ? "none"
                      : "flex",
                  paddingLeft:
                    CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF"
                      ? "10px"
                      : 0,
                }}
              >
                {/* catList */}
                <div>
                  <i
                    className="bi bi-list"
                    style={{
                      fontSize: 22,
                      position: "absolute",
                      left: 5,
                      padding: "6px 8px",
                      borderRadius: "18px",
                      color: "white",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      margin: "5px 8px 10px 8px",
                      display: CSP === "DT" || CSP === "MK" ? "block" : "none",
                    }}
                    onClick={() => {
                      this.setState({
                        showDropdown: !this.state.showDropdown,
                      });
                    }}
                  />
                </div>

                {/* switch Bed */}
                <div
                  className="DTSwitchBox"
                  style={{
                    marginLeft: CSP === "AV" ? "" : "4%",
                    width: CSP === "DT" ? "90%" : "96%",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      fontFamily: F_Fammily.Medium,
                      width: "50%",
                      textAlign: "center",
                      paddingBottom: "3%",
                      paddingTop: "3%",
                      cursor: this.state.deliveryDisabled
                        ? "not-allowed"
                        : "pointer",
                      backgroundColor:
                        this.state.ActiveIndex === 0
                          ? "white"
                          : "rgb(196, 192, 192)",
                      borderRadius: "20px",
                      color: this.state.deliveryDisabled ? "grey" : "black",
                      opacity: this.state.deliveryDisabled ? 0.5 : 1,
                      fontWeight:
                        this.state.ActiveIndex === 0 ? "bolder" : "normal",
                      fontSize: this.state.ActiveIndex === 0 ? "18px" : "15px",
                    }}
                    onClick={() => {
                      if (!this.state.deliveryDisabled) {
                        this.setState({ ActiveIndex: 0 });
                        if (
                          dto_selected_merchant_or_product.MID ===
                          dto_selected_final_merchant_or_product.MID
                        ) {
                          SET_STORE_DINE_TYPE(4);
                        }
                      }
                    }}
                  >
                    DELIVERY
                  </div>
                  <div
                    style={{
                      fontFamily: F_Fammily.Medium,
                      width: "50%",
                      textAlign: "center",
                      cursor: this.state.takeawayDisabled
                        ? "not-allowed"
                        : "pointer",
                      paddingBottom: "3%",
                      paddingTop: "3%",
                      backgroundColor:
                        this.state.ActiveIndex === 1
                          ? "white"
                          : "rgb(196, 192, 192)",
                      borderRadius: "20px",
                      color: this.state.takeawayDisabled ? "grey" : "black",
                      opacity: this.state.takeawayDisabled ? 0.5 : 1,
                      fontWeight:
                        this.state.ActiveIndex === 1 ? "bolder" : "normal",
                      fontSize: this.state.ActiveIndex === 1 ? "18px" : "15px",
                    }}
                    onClick={() => {
                      if (!this.state.takeawayDisabled) {
                        this.setState({ ActiveIndex: 1 });
                        if (
                          dto_selected_merchant_or_product.MID ===
                          dto_selected_final_merchant_or_product.MID
                        ) {
                          SET_STORE_DINE_TYPE(3);
                        }
                      }
                    }}
                  >
                    PICK UP
                  </div>
                </div>
              </div>
            </div>

            {this.state.CateList.length !== 0 ? (
              <div>
                <div
                  style={{
                    backgroundColor: "white",
                    position: "fixed",
                    left: isMobile ? 0 : WebLeft,
                    width: isMobile ? "100%" : WebWidth,
                    right: 0,
                    zIndex: 1500,
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    overflowY: "hidden",
                    padding: 5,
                    top: 48,
                    display: CSP === "MK" ? "block" : "none",
                  }}
                  id={CSP === "MK" ? "" : "cateSection"}
                >
                  {CSP !== "MK" && CSP !== "DT" ? (
                    this.state.CateList.map &&
                    this.state.CateList.map((cate, i) => {
                      let PrdList = [];
                      PrdList = JSON.parse(cate.dtoProductSessionList);
                      const isActiveCategory =
                        String(this.state.activeCategoryId) ===
                        String(cate.CATID);

                      if (PrdList.length > 0) {
                        return (
                          <div
                            key={"verticalKEY" + i + cate.CATID}
                            className={cate.CATID + "SECTIONS  btnCategorys"}
                            id={"vertical" + cate.CATID}
                            data-catid={cate.CATID}
                            style={{
                              color: isActiveCategory ? "white" : "black",
                              border: "none",
                              backgroundColor: isActiveCategory
                                ? Colors.DarkGreyScale
                                : Colors.LightGreyScale,
                              float: "none",
                              display: "inline-block",
                              zoom: 1,
                              padding: 8,
                              paddingTop: 12,
                              paddingBottom: 12,
                              marginRight: 5,
                              height: "36px",
                              fontSize: "12px",
                              fontFamily: F_Fammily.Medium,
                              borderRadius: "5px",
                            }}
                            onClick={() => {
                              if (isMobile) {
                                $("html,body").animate(
                                  {
                                    scrollTop:
                                      $("#" + cate.CATID)[0].offsetTop - 105,
                                  },
                                  1000,
                                );
                              } else {
                                $(".WindowDevice").animate(
                                  {
                                    scrollTop:
                                      $("#" + cate.CATID)[0].offsetTop - 105,
                                  },
                                  1000,
                                );
                              }
                              this.syncActiveCategory(
                                cate.CATID,
                                cate.Category.toUpperCase(),
                              );
                            }}
                          >
                            {cate.Category.toUpperCase()}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })
                  ) : (
                    <div>
                      {/* HORIZONTAL CATEGORY */}
                      <div
                        id="horizontalCateSection"
                        style={{
                          padding: "10px",
                          display:
                            this.props.params.isSec === "true"
                              ? "none"
                              : "flex",
                          overflowX: "auto",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {this.state.CategoryList.map((cate, i) => {
                          const isActiveCategory =
                            String(this.state.activeCategoryId) ===
                            String(cate.CATID);
                          return (
                            <div
                              data-catid={cate.CATID}
                              key={"dropdownKey" + i + cate.CATID}
                              style={{
                                backgroundColor: isActiveCategory
                                  ? Colors.DarkGreyScale
                                  : Colors.LightGreyScale,
                                color: isActiveCategory
                                  ? "white"
                                  : Colors.DarkGreyScale,
                                border: "1px solid #474747",
                                fontWeight: "bold",
                                fontSize: "14px",
                                padding: "5px 12px",
                                whiteSpace: "normal",
                                flex: "0 0 auto",
                                marginRight: "10px",
                                borderRadius: "6px",
                                textAlign: "center",
                              }}
                              onClick={async () => {
                                this.setState({ showDropdown: false });
                                dto_selected_merchant_or_product.CATID =
                                  cate.CATID;
                                if (cate.CATID === 0) {
                                  this.setState({ PrdList: [] });
                                  localStorage.setItem("isAllCat", true);
                                  let firstCATID =
                                    this.state.CategoryList[1].CATID;
                                  dto_selected_merchant_or_product.CATID =
                                    firstCATID;
                                  this.setState({ PrdList: [] });
                                } else {
                                  localStorage.setItem("isAllCat", "false");
                                  this.setState({ PrdList: [] });
                                }
                                dto_MobileAppCategory.ListType = cate.ListType;
                                await this.loadSubProduct();
                                this.safariTouchFix();
                                const categoryText = cate.Category;
                                const truncatedText =
                                  categoryText.length > 25
                                    ? categoryText.slice(0, 25) + "..."
                                    : categoryText;
                                this.setState({ isLoading: false });

                                setTimeout(() => {
                                  let isAllCat =
                                    localStorage.getItem("isAllCat");
                                  let firstCATID =
                                    this.state.CategoryList[1].CATID;
                                  const targetCATID =
                                    isAllCat === "true"
                                      ? firstCATID
                                      : cate.CATID;

                                  this.syncActiveCategory(
                                    targetCATID,
                                    truncatedText,
                                  );
                                  this.scrollToTarget(
                                    targetCATID + "SECTIONS",
                                    75,
                                  );
                                  this.safariTouchFix();
                                }, 100);
                              }}
                            >
                              {cate.Category.toUpperCase()}
                            </div>
                          );
                        })}
                      </div>

                      {/* CATEGORY HEADER */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "10% 75% 15%",
                          alignItems: "center",
                        }}
                      >
                        {/* Left - Menu Icon */}
                        <i
                          className="bi bi-list"
                          style={{
                            fontSize: 18,
                            borderRadius: "18px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            color: "white",
                            padding: "3px 4px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            justifySelf: "start",
                          }}
                          onClick={() =>
                            this.setState({
                              showDropdown: !this.state.showDropdown,
                            })
                          }
                        />

                        {/* Center - Header */}
                        <h1
                          id="SelectedCat"
                          style={{
                            fontSize: 24,
                            fontFamily: F_Fammily.Medium,
                            margin: 0,
                            fontWeight: "bold",
                            wordWrap: "break-word",
                            color: "black",
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          {this.state.selectedCategoryLabel}
                        </h1>

                        <i
                          className="bi bi-funnel"
                          style={{
                            fontSize: 18,
                            borderRadius: "18px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            color: "white",
                            padding: "3px 4px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            justifySelf: "end",
                          }}
                          onClick={() =>
                            this.setState({
                              showSortDropDown: true,
                            })
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="container"
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: CSP === "MK" ? 90 : 0,
                  }}
                >
                  <div>
                    {this.state.PrdList.map &&
                      this.state.PrdList.map((cate, i) => {
                        let PrdList = [];
                        PrdList = JSON.parse(cate.dtoProductSessionList);
                        if (PrdList.length > 0) {
                          return (
                            <div
                              className="ItemList"
                              id={cate.CATID + "SECTIONS"}
                              key={cate.CATID + "ProductList" + i + "Key"}
                            >
                              <div
                                className="row"
                                key={cate.CATID + i + "Key"}
                                style={{ display: "block" }}
                              >
                                <Category
                                  Category={cate.Category.toUpperCase()}
                                  ID={cate.CATID}
                                  key={
                                    cate.CATID + "CategoryHeading" + i + "Key"
                                  }
                                />
                              </div>
                              <div className="" key={i + cate.CATID + "PRD"}>
                                {PrdList.map((item, i) => {
                                  return (
                                    <React.Fragment
                                      key={item.PI + "ProductList" + i}
                                    >
                                      <ItemView
                                        onClick={async (rs, index) => {
                                          await Api_DrawAnalyticalPath(1, rs);
                                          ENCRYPT_STORAGE_SESSION.setItem(
                                            "PrdIdScroll",
                                            rs + "PRD" + index,
                                          );

                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list",
                                            )
                                              .replace(
                                                ":navigatepage",
                                                "product-list",
                                              )
                                              .replace(
                                                ":category",
                                                cate.Category.replace(
                                                  "/",
                                                  "-",
                                                ).toLowerCase(),
                                              )
                                              .replace(":pid", rs)
                                              .replace(":lineid", 1)
                                              .replace(":adonlineid", 1)
                                              .replace(":isrecommended", 0),
                                          );
                                          this.safariTouchFix();
                                        }}
                                        pid={item.PI}
                                        data={item}
                                        index={i}
                                        Description={item.D}
                                        GenDesc={item.G}
                                        SP={item.P}
                                        UD={item.UD}
                                        IsAvailable={item.A}
                                        ProductImage={
                                          <div className="">
                                            {item.IU !== "" &&
                                            item.IU !== "N/A" ? (
                                              <img
                                                style={{
                                                  height: 70,
                                                  width: 70,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                }}
                                                loading="lazy"
                                                id={"prdImageLise" + item.PI}
                                                src={item.IU.split("λ")[0]}
                                                alt=""
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: 30,
                                                  width: 30,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                  filter: "grayscale(100%)",
                                                  WebkitFilter:
                                                    "grayscale(100%)",
                                                }}
                                                src={dto_common.DefaultImageUrl}
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                                alt=""
                                              />
                                            )}
                                          </div>
                                        }
                                      />
                                      <div
                                        style={{
                                          borderTop: "1px solid black",
                                          transform: "scaleY(0.1)",
                                          display: "block",
                                        }}
                                      />
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>

                  {this.state.displayMessage ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "70px",
                        height: "100vh",
                      }}
                    >
                      <img
                        src={require("./images/NoDataFound.jpg")}
                        width={"60%"}
                        alt=""
                      />

                      <label
                        style={{
                          fontWeight: "bold",
                          marginBottom: "8px",
                          textAlign: "center",
                        }}
                      >
                        We did not find a match
                      </label>
                      <label style={{ textAlign: "center" }}>
                        Try searching for something instead
                      </label>

                      <div
                        style={{
                          display: CSP === "MK" ? "block" : "none",
                          backgroundColor: Colors.DarkGreyScale,
                          borderRadius: "4px",
                          color: "white",
                          marginTop: "40px",
                          padding: "4px 8px",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          this.props.navigate(
                            PT_FILTER_OUTLETS_PRODUCTS.replace(
                              ":frmpath",
                              "category",
                            ),
                          );
                          let filterText = document.getElementById(
                            "InputproductlistFilterTextBox",
                          ).value;
                          ENCRYPT_STORAGE.setItem(
                            "SearchStringFilter",
                            filterText,
                          );
                        }}
                      >
                        Find More at Other <br />
                        Categories
                      </div>
                    </div>
                  ) : null}
                  {!this.state.displayMessage && CSP === "MK" ? (
                    <div
                      style={{
                        backgroundColor: Colors.DarkGreyScale,
                        borderRadius: "4px",
                        color: "white",
                        margin: "24px auto 0",
                        padding: "4px 8px",
                        textAlign: "center",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "category",
                          ),
                        );
                        let filterText = document.getElementById(
                          "InputproductlistFilterTextBox",
                        ).value;
                        ENCRYPT_STORAGE.setItem(
                          "SearchStringFilter",
                          filterText,
                        );
                      }}
                    >
                      Find More at Other <br />
                      Categories
                    </div>
                  ) : null}
                </div>

                {!this.state.displayMessage ? (
                  <button
                    id="ScrollToTopBTN"
                    title="Go to top"
                    style={{ left: isMobile ? "80%" : "63%" }}
                    onClick={() => {
                      if (isMobile) {
                        window.scrollTo({ top: 10, behavior: "smooth" });
                      } else {
                        const el = document.querySelector(".WindowDevice");
                        el && el.scrollTo({ top: 10, behavior: "smooth" });
                      }
                    }}
                  >
                    <i
                      className="bi bi-arrow-up-square"
                      style={{ fontSize: 28 }}
                    />
                  </button>
                ) : null}

                {/* View Basket For View Cart */}
                {this.state.LocalCart.length > 0 ? (
                  <QuickCartButton
                    totalPrice={this.getTotalPrice()}
                    itemCount={this.state.LocalCart.length}
                    onClick={async () => {
                      let Localcart = await GET_CART();
                      if (Localcart === undefined) {
                        Localcart = [];
                      }
                      this.setState(
                        { IsSummaryCart: true, LocalCart: Localcart },
                        async () => {
                          await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(
                            async () => {
                              let Localcart = await GET_CART();
                              if (Localcart === undefined) {
                                Localcart = [];
                              }
                              this.setState({
                                IsSummaryCart: false,
                                LocalCart: Localcart,
                              });
                            },
                          );
                        },
                      );
                    }}
                  />
                ) : null}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "70px",
                  height: "100vh",
                }}
              >
                <img
                  src={require("./images/NoDataFound.jpg")}
                  width={"60%"}
                  alt=""
                />

                <label
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                    textAlign: "center",
                  }}
                >
                  We did not find a match
                </label>
                <label style={{ textAlign: "center" }}>
                  Try searching for something instead
                </label>
              </div>
            )}
          </>
        )}

        <DrawerSheetBottom
          open={this.state.showDropdown}
          closeFunction={() => this.setState({ showDropdown: false })}
          displayCloseIcon="block"
          element={
            <div style={{ position: "relative", height: "100%" }}>
              <div
                style={{
                  maxHeight: "calc(100% - 70px)",
                  overflowY: "auto",
                }}
              >
                {this.state.CategoryList.map((cate, i) => {
                  return (
                    <div
                      data-catid={cate.CATID}
                      key={"dropdownKey" + i + cate.CATID}
                      style={{
                        padding: "12px 12px",
                        cursor: "pointer",
                        fontSize: "16px",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={async () => {
                        this.setState({ showDropdown: false }, () => {
                          this.safariTouchFix();
                        });

                        dto_selected_merchant_or_product.CATID = cate.CATID;
                        if (cate.CATID === 0) {
                          this.setState({ PrdList: [] });
                          localStorage.setItem("isAllCat", true);
                          let firstCATID = this.state.CategoryList[1].CATID;
                          dto_selected_merchant_or_product.CATID = firstCATID;
                          this.setState({ PrdList: [] });
                        } else {
                          localStorage.setItem("isAllCat", "false");
                          this.setState({ PrdList: [] });
                        }
                        await this.loadSubProduct();
                        this.safariTouchFix();
                        const categoryText = cate.Category;
                        const truncatedText =
                          categoryText.length > 25
                            ? categoryText.slice(0, 25) + "..."
                            : categoryText;
                        this.setState({ isLoading: false });

                        setTimeout(() => {
                          const targetCATID =
                            cate.CATID === 0 &&
                            this.state.CategoryList.length > 1
                              ? this.state.CategoryList[1].CATID
                              : cate.CATID;
                          this.syncActiveCategory(targetCATID, truncatedText);
                          this.scrollToTarget(targetCATID + "SECTIONS");
                        }, 100);
                      }}
                    >
                      {cate.Category.toUpperCase()}
                    </div>
                  );
                })}
              </div>

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ showDropdown: false })}
              >
                {" "}
                Dismiss{" "}
              </button>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Categories"
        />

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          closeFunction={() =>
            this.setState({ IsSummaryCart: false }, () => {
              this.safariTouchFix();
            })
          }
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0),
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({
                  LocalCart: updatedCart,
                  IsSummaryCart: updatedCart.length > 0,
                });
              }}
              closeFunction={() =>
                this.setState({ IsSummaryCart: false }, () => {
                  this.safariTouchFix();
                })
              }
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />
        <DrawerSheetBottom
          open={this.state.showSortDropDown}
          closeFunction={() => this.setState({ showSortDropDown: false })}
          element={
            <div>
              {/* A-Z */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("A_TO_Z")}
              >
                <i
                  className="bi bi-sort-alpha-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort A - Z
                </span>
              </div>
              <br />

              {/* Z-A */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("Z_TO_A")}
              >
                <i
                  className="bi bi-sort-alpha-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort Z - A
                </span>
              </div>
              <br />

              {/* Price Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-numeric-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price low to high
                </span>
              </div>
              <br />

              {/* Price High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-numeric-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price high to low
                </span>
              </div>
              <br />

              {/* Discount Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % low to high
                </span>
              </div>
              <br />

              {/* Discount High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % high to low
                </span>
              </div>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Sort Products"
        />
      </div>
    );
  }

  async Setdinetype() {
    let DineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
    const hasDineType = !Number.isNaN(DineType);
    let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PRODUCT_LIST);
    const MerchantDetails =
      dataStorage?.MerchantData ||
      this.state.MerchantData ||
      dto_selected_final_merchant_or_product ||
      dto_selected_merchant_or_product;

    if (
      MerchantDetails === undefined ||
      MerchantDetails === null ||
      Number.isNaN(Number(MerchantDetails?.MID))
    ) {
      return;
    }

    let SelectedMerchantDineType = Number(MerchantDetails.DineType);

    if (!hasDineType) {
      if (SelectedMerchantDineType === 0) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
        this.setState({ ActiveIndex: 0 });
      }
      if (SelectedMerchantDineType === 4) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
      } else if (SelectedMerchantDineType === 3) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
      }
    } else {
      if (SelectedMerchantDineType === 4 && DineType !== 4) {
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
      if (SelectedMerchantDineType === 3 && DineType !== 3) {
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 4 && DineType === 4) {
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
      if (SelectedMerchantDineType === 3 && DineType === 3) {
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 0 && DineType === 3) {
        this.setState({
          ActiveIndex: 1,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 0 && DineType === 4) {
        this.setState({
          ActiveIndex: 0,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
    }
  }

  sortProducts = (sortType) => {
    const ProductListt = [...this.state.PrdList];
    const selectedCATID = dto_selected_merchant_or_product.CATID;
    let targetIndex = ProductListt.findIndex(
      (item) => item.CATID === selectedCATID,
    );

    if (targetIndex === -1) {
      targetIndex = 0;
    }

    if (!ProductListt[targetIndex]) {
      this.setState({ showSortDropDown: false });
      return;
    }

    const PromoProductList = { ...ProductListt[targetIndex] };
    let PrdList = JSON.parse(PromoProductList.dtoProductSessionList || "[]");

    switch (sortType) {
      case "A_TO_Z":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
        break;

      case "Z_TO_A":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameB.localeCompare(nameA);
        });
        break;

      case "PRICE_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceA - priceB;
        });
        break;

      case "PRICE_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceB - priceA;
        });
        break;

      case "DISCOUNT_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentA - discountPercentB;
        });
        break;

      case "DISCOUNT_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentB - discountPercentA;
        });
        break;

      default:
        break;
    }

    PromoProductList.dtoProductSessionList = JSON.stringify(PrdList);
    ProductListt[targetIndex] = PromoProductList;
    this.setState({
      PrdList: ProductListt,
      CateList: ProductListt,
      showSortDropDown: false,
    });

    if (isMobile) {
      $("html,body").animate({ scrollTop: 10 }, 700);
    } else {
      $(".WindowDevice").animate({ scrollTop: 10 }, 700);
    }
  };

  async TransformationFillterTextBox() {
    var element = document.getElementsByClassName("transform");
    element[0].classList.add("transform-active-fillter-product");
    $(".productlistFilterTextBox").fadeIn(1000);
    this.focusSearchInput();

    FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS({
      FnFilterTextBox: (e) => {
        this.InputproductlistFilterTextBoxOnChange(e);
      },
      FnFilterCloseButton: (e) => {
        if (element) {
          element[0].classList.remove("transform-active-fillter-product");
          $(".productlistFilterTextBox").fadeOut(800);
          const el = document.getElementById("NewFilterationTextBox");
          if (el) {
            el.classList.remove("active");
            $("#NewFilterationTextBox").fadeOut(800);
          }

          this.setState({
            PrdList: this.state.inMemoryProducts,
            CateList: this.state.inMemoryProducts,
            displayMessage: false,
          });
        }
      },
      FnFilterClearButton: (e) => {
        this.setState((state) => {
          const PrdList = [...this.state.inMemoryProducts];
          const CateList = [...this.state.inMemoryProducts];
          const displayMessage = false;
          return {
            PrdList,
            CateList,
            displayMessage,
          };
        });
      },
    });
  }

  async LoadMasterCategory() {
    let data = await api_CategoryPageLoadGroceryCategory();
    let objData = JSON.parse(data);
    this.setState({ CategoryList: objData });
  }

  async LoadApiProduct() {
    let data = await api_LoadProductListToMobileAppForAnMID();
    let ObjData = JSON.parse(data);
    let ProductList = ObjData[0];
    let ProductListt;
    if (
      (CSP === "MK" &&
        dto_selected_merchant_or_product.CATID !== 1 &&
        ProductList.length !== 1) ||
      (CSP === "DT" &&
        dto_selected_merchant_or_product.Merchant === "MKB Supermarket" &&
        dto_selected_merchant_or_product.CATID !== 1)
    ) {
      let withoutOffer = ProductList.filter(
        (item) => item.Category !== "OFFER",
      );
      ProductListt = withoutOffer;
    } else {
      ProductListt = ProductList;
    }
    let MerchantDataa = ObjData[1];
    this.setState({ MerchantData: MerchantDataa });
    ENCRYPT_STORAGE.removeItem(STORE_PRODUCT_LIST);
    ENCRYPT_STORAGE.setItem(STORE_PRODUCT_LIST, {
      ProductList: ProductListt,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      date: new Date(),
      CATID: dto_selected_merchant_or_product.CATID,
    });
    return ProductListt;
  }

  async LoadProduct() {
    try {
      this.setState({ isLoading: true });
      let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PRODUCT_LIST);
      let data = "";
      if (dataStorage !== undefined && dataStorage !== "") {
        if (dataStorage.MID === dto_selected_merchant_or_product.MID) {
          let StorageDateTime = new Date(dataStorage.date);
          let currentDateTime = new Date();
          let DifferenceMinute = DIFERENCE_MINUTES(
            currentDateTime,
            StorageDateTime,
          );
          if (DifferenceMinute > 1) {
            ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
            data = await this.LoadApiProduct();
          } else {
            if (
              dto_selected_merchant_or_product.MT === "GR" ||
              dto_selected_merchant_or_product.MT === "AF" ||
              CSP === "MK"
            ) {
              if (
                dataStorage.CATID === dto_selected_merchant_or_product.CATID
              ) {
                data = dataStorage.ProductList;
                this.setState({ MerchantData: dataStorage.MerchantData });
              } else {
                ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                data = await this.LoadApiProduct();
              }
            } else {
              data = dataStorage.ProductList;
              this.setState({ MerchantData: dataStorage.MerchantData });
            }
          }
        } else {
          ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
          data = await this.LoadApiProduct();
        }
      } else {
        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
        data = await this.LoadApiProduct();
      }

      let Localcart = await GET_CART();
      if (Localcart === undefined) {
        Localcart = [];
      }

      this.setState(
        {
          CateList: data,
          PrdList: data,
          inMemoryProducts: data,
          isLoading: false,
          LocalCart: Localcart,
        },
        () => {},
      );

      setTimeout(async () => {
        if (!this.state.isLoading) {
          await this.ScrollIndicaterMenu();
        }
      }, 500);

      setTimeout(() => {
        let PID = ENCRYPT_STORAGE_SESSION.getItem("PrdIdScroll");
        if (PID !== undefined) {
          this.scrollToTarget(PID, 110);
        } else {
          const container = isMobile
            ? document.querySelector(".body-container")
            : document.querySelector(".WindowDevice");
          if (container && container.scrollTo) {
            container.scrollTo({ top: 10, behavior: "auto" });
          } else {
            window.scrollTo({ top: 10, behavior: "auto" });
          }
        }
      }, 100);
      setTimeout(() => {
        let cateSection = document.getElementById("cateSection");
        if (cateSection) {
          cateSection.style.display = "none";
        }
      }, 50);
    } catch (error) {
      console.error("LoadProductList : " + error);
    }
  }

  async loadSubProduct() {
    try {
      this.setState({ isLoading: true });
      let SelectedCATID = dto_selected_merchant_or_product.CATID;
      let prdlist = this.state.PrdList;
      let isAllCat = localStorage.getItem("isAllCat");

      let firstCATID = this.state.CategoryList[1].CATID;
      localStorage.setItem("firstCATID", firstCATID);

      const isMatch = prdlist.some((item) => item.CATID === SelectedCATID);
      if (!isMatch || firstCATID === SelectedCATID) {
        if (isAllCat === "true") {
          let data = await this.LoadApiProduct();
          this.setState((prevState) => ({
            PrdList: [...prevState.PrdList, ...data],
          }));
        } else {
          let data = await this.LoadApiProduct();
          this.setState({ PrdList: data });
        }
      } else if (isMatch && SelectedCATID === prdlist[0].CATID) {
        let data = await this.LoadApiProduct();
        this.setState({ PrdList: data });
      } else {
        let data = await this.LoadApiProduct();
        this.setState({ PrdList: data });
      }

      this.setState({ isLoading: false });
    } catch (error) {
      console.error("Error loading sub-products:", error);
    }
  }

  async ScrollIndicaterMenu() {
    let ItemSection = document.getElementsByClassName("ItemList");

    let element;
    if (isMobile) {
      element = document.querySelector(".body-container");
    } else {
      element = document.querySelector(".WindowDevice");
    }

    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }

    this.handleScroll = async () => {
      const top = element ? element.scrollTop : 0;
      for (let i = 0; i < ItemSection.length; i++) {
        let offset = ItemSection[i].offsetTop - 120;
        let Height = ItemSection[i].offsetHeight;
        let ID = ItemSection[i].id;
        let ScrollToTopBTN = document.getElementById("ScrollToTopBTN");

        if (top > 252) {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = "block";
          }
          if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
            $("#DivHeaderHome").show(500);
          }
        } else {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = "none";
          }
          if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
            $("#DivHeaderHome").hide(500);
            this.setState({
              MainTopMargin: "0px",
              iconDisplay: "block",
            });
          }
        }

        if (top > 1630) {
          ScrollToTopBTN.style.display = "none";
        } else {
          ScrollToTopBTN.style.display = "none";
        }

        if (top >= offset && top < offset + Height) {
          if (CSP === "MK" || CSP === "DT") {
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            const currentCATID = ID.replace("SECTIONS", "");
            this.syncActiveCategory(currentCATID, CategoryName);
            setTimeout(() => {
              this.safariTouchFix();
            }, 0);

            if (
              CSP === "MK" ||
              (CSP === "DT" &&
                dto_selected_merchant_or_product.Merchant === "MKB Supermarket")
            ) {
              let SelectedCATID = dto_selected_merchant_or_product.CATID;
              const isScrolledToBottom =
                element.scrollTop + element.clientHeight >=
                element.scrollHeight;
              let CategoryList = this.state.CategoryList;
              let isAllCat = localStorage.getItem("isAllCat");

              if (isScrolledToBottom && isAllCat === "true") {
                if (CategoryList && CategoryList.length > 0) {
                  const index = CategoryList.findIndex(
                    (item) => item.CATID === SelectedCATID,
                  );

                  if (index !== -1 && index < CategoryList.length - 1) {
                    const nextCATID = CategoryList[index + 1].CATID;
                    SelectedCATID = dto_selected_merchant_or_product.CATID =
                      nextCATID;

                    await this.loadSubProduct();
                    this.safariTouchFix();
                  }
                }
              }
            }
          } else {
            const currentCATID = ID.replace("SECTIONS", "");
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            this.syncActiveCategory(currentCATID, CategoryName);

            const cateSection = document.getElementById("cateSection");
            const activeBtn = document.getElementById(
              "vertical" + currentCATID,
            );
            if (cateSection && activeBtn) {
              const left =
                activeBtn.offsetLeft -
                cateSection.clientWidth / 2 +
                activeBtn.clientWidth / 2;

              cateSection.scrollTo({
                left: Math.max(0, left),
                behavior: "smooth",
              });
            }
          }
        }
      }
    };
    if (element) {
      element.addEventListener("scroll", this.handleScroll);
    }
    this.handleScroll();
  }

  handleFilterChange = (e) => {
    const filterText = e.target.value;
    this.setState({ filterText });
    this.filterProductList(filterText.toLowerCase());
  };

  checkIsFavourite() {
    let fav = ENCRYPT_STORAGE.getItem(STORE_FAVOURITE_MERCHANT_LIST);
    if (fav !== undefined) {
      for (let i = 0; i < fav.length; i++) {
        if (fav[i].MID === dto_Merchant.MID) {
          this.setState({ IsFavourite: true });
          return;
        }
      }
    }
  }

  filterProductList = (filterText) => {
    const filteredCateList = this.state.inMemoryProducts
      .map((category) => {
        const filteredProducts = JSON.parse(
          category.dtoProductSessionList,
        ).filter((product) => product.D.toLowerCase().includes(filterText));
        return {
          ...category,
          dtoProductSessionList: JSON.stringify(filteredProducts),
        };
      })
      .filter(
        (category) => JSON.parse(category.dtoProductSessionList).length > 0,
      );

    this.setState({
      CateList: filteredCateList,
      PrdList: filteredCateList,
      displayMessage: filteredCateList.length === 0,
    });
  };

  resetFilter = () => {
    this.setState({
      CateList: this.state.inMemoryProducts,
      PrdList: this.state.inMemoryProducts,
      displayMessage: false,
      filterText: "",
    });
  };

  handleCancelClick = () => {
    $("#NewFilterationTextBox").animate(
      {
        height: "toggle",
      },
      500,
      () => {
        const el = document.getElementById("NewFilterationTextBox");
        if (el) {
          el.classList.remove("active");
        }
        this.resetFilter();
        const overlay = document.querySelector(".shadow-overlay");
        if (overlay) {
          overlay.style.display = "none";
        }
        $("#NewFilterationTextBox").hide();
      },
    );
  };

  handleHeartClick = async (event) => {
    this.setState(
      (prevState) => ({ IsFavourite: !prevState.IsFavourite }),
      async () => {
        await api_UpdateIsFavouriteForMerchant(
          dto_Merchant.MID,
          this.state.IsFavourite,
        );

        let fav = ENCRYPT_STORAGE.getItem(STORE_FAVOURITE_MERCHANT_LIST);
        let foundIndex = fav.findIndex((item) => item.MID === dto_Merchant.MID);
        if (foundIndex !== -1) {
          fav[foundIndex].isFavourite = this.state.IsFavourite;
          ENCRYPT_STORAGE.setItem(STORE_FAVOURITE_MERCHANT_LIST, fav);
        }
      },
    );
  };

  InputproductlistFilterTextBoxOnChange(e) {
    let item = [];
    let IsFiltered = false;
    let TempItems = cloneDeep(this.state.inMemoryProducts);
    TempItems.forEach((rs) => {
      let lIstArrayPrd = [];
      let products = JSON.parse(rs.dtoProductSessionList);

      products.filter((prd) => {
        let isMatch = prd.D.toLowerCase().includes(
          e.currentTarget.value.toLowerCase(),
        );
        if (isMatch) {
          IsFiltered = true;
          lIstArrayPrd.push(prd);
        }
        return isMatch;
      });

      rs.dtoProductSessionList = JSON.stringify(lIstArrayPrd);
      item.push(rs);
    });
    if (IsFiltered) {
      this.setState({ PrdList: item, CateList: item, displayMessage: false });
    } else {
      this.setState({ PrdList: item, CateList: item, displayMessage: true });
    }
  }
}
